// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultsLabel_root__M3TrF","rotation":"ResultsLabel_rotation__nNz9F"};